
const digest = 'cdc4892234774cce158adf47049daeea65ecc8bbe96c6fe205bfd1c742c3e1b3';
const classes = {"controls":"_controls_1yu2c_1","errorMessage":"_errorMessage_1yu2c_9"};
const css = `._controls_1yu2c_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin-top: 35px;
}

._errorMessage_1yu2c_9 {
  margin-top: 10px;
  color: #dc3545;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  